import React, { useCallback, useEffect, useState } from "react";
import { DispatchTransactionEvent } from "../events/events";
import {
  SUSPENDED, ShowError, confirmationDialog, 
  JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, 
  JSON_KEY_SUBMITTER, JSON_KEY_STATUS,
  ITEM_STATUS, ITEM_CREATE, ITEM_MODIFY, StatusIndexOptions,
  JSON_KEY_DESCRIPTION, JSON_KEY_INDEX,
  JSON_KEY_PRICE_DECIMALS, JSON_KEY_PRICE,
  EVENT_TYPE_INDICES_STATUS,
  EVENT_TYPE_INDICES_CREATE,
  EVENT_TYPE_INDICES_MODIFY,
  ConvertStatus,
  ConvertStatusFromNameToId,
  STATUS_NEW,
  JSON_KEY_MININMUM_VALUE,
  JSON_KEY_VALIDATE_ORDERS,
  JSON_KEY_MAXINMUM_VALUE,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectTSUserId } from "../../redux/globalsSlice";
import { MSG_TYPE_INDICES_CREATE, MSG_TYPE_INDICES_MODIFY, MSG_TYPE_INDICES_STATUS } from "../../common/msg_types";
import { RenderDropdown, InputField, CleanNumber } from "../../common/utilies";
import { ConvertFromTradingRulesValueName, yesNoOptions } from "../../common/convert_functions";

const IndicesAdminForm = ({ rowData, onClose, indicesOptions }) => {
   const userId = useSelector(selectTSUserId);
   const [selectedTabIndex, setSelectedTabIndex] = useState(0);

   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   // tab1
   const [code, setCode] = useState(rowData?.idx || "");
   const [status, setStatus] = useState(ConvertStatusFromNameToId(rowData?.status ?? SUSPENDED));

   // tab 2 & 3
   const [description, setDescription] = useState(rowData?.descr || "");
   const [value, setValue] = useState(CleanNumber(rowData?.price) ?? "");
   const [priceDecimals, setPriceDecimals] = useState(CleanNumber(rowData?.price_dec) ?? "");
   const [minimum_value, setMinimumValue] = useState(CleanNumber(rowData?.min) ?? "");
   const [maximum_value, setMaximumValue] = useState(CleanNumber(rowData?.max) ?? "");
   const [validate_orders, setValidateOrders] = useState(ConvertFromTradingRulesValueName(rowData?.val_ord));

   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   const onIndexDropDownChange = useCallback((e) => setCode(e.target.value), [setCode]);
   const onStatusDropDownChange = useCallback((e) => setStatus(e.target.value), [setStatus]);
   const onYesNoDropDownChange = useCallback((e) => {setValidateOrders(e.target.value)}, [setValidateOrders]);
   // const onYesNoDropDownChange = useCallback((e) => {setValidateOrders(e.target.value === 'Yes' ? 'Y' : 'N')}, [setValidateOrders]);

   const onIndexModifyDropDownChange = (e) => {
      setCode(e.target.value);
      setDescription('');
      setStatus(SUSPENDED);
   };

   const ConfirmAndSubmit = async ({ title, text, item }) => {
      const confirmed = await confirmationDialog({ title, text });
      if (confirmed) handleStatusConfirmationSubmit(item);
   };

   const handleStatusConfirmationSubmit = (submitItem) => {
      const base = {
         [JSON_KEY_SUBMITTER]: userId,
         [JSON_KEY_INDEX]: code,
      };

      // Scale the values (or return empty string if missing)
      const scaledPrice = value !== "" && priceDecimals !== "" 
         ? Math.round(parseFloat(value) * Math.pow(10, parseInt(priceDecimals))) : "";
      
      const scaledMinimumValue = minimum_value !== "" && priceDecimals !== "" 
         ? Math.round(parseFloat(minimum_value) * Math.pow(10, parseInt(priceDecimals))) : "";
      
      const scaledMaximumValue = maximum_value !== "" && priceDecimals !== "" 
         ? Math.round(parseFloat(maximum_value) * Math.pow(10, parseInt(priceDecimals))) : "";

      // Common payload for CREATE and MODIFY
      const commonPayload = {
         [JSON_KEY_MESSAGE_TYPE]: submitItem === ITEM_CREATE ? MSG_TYPE_INDICES_CREATE : MSG_TYPE_INDICES_MODIFY,
         [JSON_KEY_DESCRIPTION]: description,
         [JSON_KEY_PRICE]: scaledPrice,
         [JSON_KEY_PRICE_DECIMALS]: Number(priceDecimals),
         [JSON_KEY_VALIDATE_ORDERS]: validate_orders,
         [JSON_KEY_STATUS]: status,
      };

      // **Conditionally add min and max only if they are not empty**
      console.log("min: ", scaledMinimumValue, ", max: ", scaledMaximumValue);
      if (scaledMinimumValue !== "" && !Number.isNaN(scaledMinimumValue)) {
         commonPayload[JSON_KEY_MININMUM_VALUE] = Number(scaledMinimumValue);
      }

      if (scaledMaximumValue !== "" && !Number.isNaN(scaledMaximumValue)) {
         commonPayload[JSON_KEY_MAXINMUM_VALUE] = Number(scaledMaximumValue);
      }

      // if (scaledMinimumValue !== "") {
      //    commonPayload[JSON_KEY_MININMUM_VALUE] = Number(scaledMinimumValue);
      // }
      
      // if (scaledMaximumValue !== "") {
      //    commonPayload[JSON_KEY_MAXINMUM_VALUE] = Number(scaledMaximumValue);
      // }

      switch (submitItem) {
         case ITEM_STATUS:
            DispatchTransactionEvent(
            EVENT_TOPIC_FOR_TRANSACTION_SERVER,
            EVENT_TYPE_INDICES_STATUS,
            {
               ...base,
               [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_INDICES_STATUS,
               [JSON_KEY_STATUS]: status,
            }
            );
            break;

         case ITEM_CREATE:
            DispatchTransactionEvent(
            EVENT_TOPIC_FOR_TRANSACTION_SERVER,
            EVENT_TYPE_INDICES_CREATE,
            {
               ...base,
               ...commonPayload,   // includes min/max only if present
            }
            );
            break;

         case ITEM_MODIFY:
            DispatchTransactionEvent(
            EVENT_TOPIC_FOR_TRANSACTION_SERVER,
            EVENT_TYPE_INDICES_MODIFY,
            {
               ...base,
               ...commonPayload,
            }
            );
            break;

         default:
            console.log("IndicessAdminForm unknown submit item");
      }
   };

   const ValidateFields = () => {
      if (!code) return "Code is missing";
      if (!description) return "Description is missing";
      if (!status) return "Status is missing";
      return null;
   };

   const handleStatusSubmit = () => {
      if (status === STATUS_NEW) return ShowError("Status cannot be New");

      ConfirmAndSubmit({
         title: "Index Status Change",
         text: `Setting Index ${code} to ${ConvertStatus(status)}`,
         item: ITEM_STATUS,
      });
      onClose(); // your modal close function
   };

   const handleCreateSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Create Index",
         text: `Creating new Index: ${code}`,
         item: ITEM_CREATE,
      });
      onClose(); // your modal close function
   };

   const handleModifySubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Modify Index",
         text: `Modifying index: ${code}`,
         item: ITEM_MODIFY,
      });
      onClose(); // your modal close function
   };

   useEffect(() => {
   if (!rowData) return;
      setCode(rowData.idx || "");
      setDescription(rowData.descr || "");
      setStatus(ConvertStatusFromNameToId(rowData?.status ?? SUSPENDED));
      setValue(CleanNumber(rowData.price) ?? "");
      setMinimumValue(CleanNumber(rowData.min) ?? "");
      setMaximumValue(CleanNumber(rowData.max) ?? "");
      // setValidateOrders(ConvertFromTradingRulesValueName(rowData.val_ord));
      setPriceDecimals(CleanNumber(rowData.price_dec) ?? "");
   }, [rowData]);

   useEffect(() => {
      if (selectedTabIndex === 2) {
         setStatus(SUSPENDED);
      }
   }, [selectedTabIndex]);

   return (
      <div className="admin-form">
         <div className="admin-tabs">
         <h2 className="center-heading">Index Administration</h2>
         <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} forceRenderTabPanel={true} className="admin-tabs" >
            <TabList>
               <Tab>Change Status</Tab>
               <Tab>Modify Index</Tab>
               <Tab>Create Index</Tab>
            </TabList>

            {/* Tab 1: Change Status */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleStatusSubmit)}>
               <div className="top">
                  {RenderDropdown("Index", code, indicesOptions, onIndexDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Status", status, StatusIndexOptions, onStatusDropDownChange)}
               </div>
               
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 2: Modify Index */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleModifySubmit)}>
               <div className="top">
                  {RenderDropdown("Index", code, indicesOptions, onIndexModifyDropDownChange)}
               </div>

               <div>
                  <InputField label="Description" value={description} onChange={setDescription} />
               </div>

               <div>
                  <InputField label="Price Decimals" value={priceDecimals} onChange={setPriceDecimals} type="number" />
               </div>

               <div>
                  <InputField label="Value" value={value} onChange={setValue} type="number" />
               </div>

               <div>
                  <InputField label="Min Trade Value" value={minimum_value} onChange={setMinimumValue} type="number" />
               </div>

               <div>
                  <InputField label="Max Trade value" value={maximum_value} onChange={setMaximumValue} type="number" />
               </div>

               <div className="top">
                  {RenderDropdown("Validate Orders", validate_orders, yesNoOptions, onYesNoDropDownChange)}
               </div>  

               {/* <div className="top">
                  {RenderDropdown("Status", status, StatusIndexOptions, onStatusDropDownChange)}
               </div> */}

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            
            
            {/* Tab 3: Create Index */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCreateSubmit)}>
               <div>
                  <InputField label="Code" value={code} onChange={setCode} />
               </div>

               <div>
                  <InputField label="Description" value={description} onChange={setDescription} />
               </div>

               <div>
                  <InputField label="Price Decimals" value={priceDecimals} onChange={setPriceDecimals} type="number" />
               </div>

               <div>
                  <InputField label="Value" value={value} onChange={setValue} type="number" />
               </div>

               <div>
                  <InputField label="Min Trade Value" value={minimum_value} onChange={setMinimumValue} type="number" />
               </div>

               <div>
                  <InputField label="Max Trade value" value={maximum_value} onChange={setMaximumValue} type="number" />
               </div>

               <div className="top">
                  {RenderDropdown("Validate Orders", validate_orders, yesNoOptions, onYesNoDropDownChange)}
               </div>  

               {/*
               <div className="top">
                  {RenderDropdown("Status", status, StatusIndexOptions, onStatusDropDownChange, true)}
               </div>
               */}
               
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>
         </Tabs>
         </div>
      </div>
   );
};

export default IndicesAdminForm;
